export default "__VITE_ASSET__3d89a277__"